import React from "react"
import { ReactComponent as MexicoIcon } from "../../design/assests/images/icons/mexico-vacation-schema.svg"
import { ReactComponent as ForeignIcon } from "../../design/assests/images/icons/foreign-vacation-schema.svg"
import { ReactComponent as SisuIcon } from "../../design/assests/images/icons/sisu-icon.svg"
import Tooltip from "../atoms/Tooltip.atom"
import { generateRandomId } from "../../utils/strings.utils"

export const ICON_MAP = {
  Mexicano: {
    icon: MexicoIcon,
    className: "vacation-schema--mexico",
    showTooltip: true,
  },
  "Nacional v2019": {
    icon: MexicoIcon,
    className: "vacation-schema--mexico",
    showTooltip: true,
  },
  "Nacional v2024": {
    icon: MexicoIcon,
    className: "vacation-schema--mexico",
    showTooltip: true,
  },
  Extranjero: {
    icon: ForeignIcon,
    className: "vacation-schema--foreign",
    showTooltip: false,
  },
  Internacional: {
    icon: ForeignIcon,
    className: "vacation-schema--foreign",
    showTooltip: false,
  },
  Sisu: {
    icon: SisuIcon,
    className: "vacation-schema--sisu",
    showTooltip: true,
  },
  Global: {
    icon: SisuIcon,
    className: "vacation-schema--sisu",
    showTooltip: true,
  },
}

/**
 * @param {VacationFlagProps} param0
 */
const VacationFlag = ({ schemaTitle, tooltipConfig, showTooltip = false }) => {
  if (!schemaTitle || !ICON_MAP[schemaTitle]) return null
  const {
    icon: Icon,
    className,
    showTooltip: allowTooltip,
  } = ICON_MAP[schemaTitle]
  const id = generateRandomId()
  const containerClass = `vacation-schema vacation-schema-icon-container-${id} ${className}`

  return (
    <div className={containerClass}>
      <Icon className="vacation-schema__icon" />
      {showTooltip && allowTooltip && (
        <Tooltip
          target={`.vacation-schema-icon-container-${id}`}
          className="vacation-schema__tooltip"
          {...tooltipConfig}
        />
      )}
    </div>
  )
}

export default VacationFlag

/**
 * @typedef {Object} VacationFlagProps
 * @property {keyof ICON_MAP} schemaTitle - Title of the vacation schema (e.g., "Mexicano", "Extranjero", "Sisu").
 * @property {Object} [tooltipConfig] - Optional configuration for the tooltip.
 * @property {boolean} [showTooltip=false] - Flag to determine if the tooltip should be shown.
 */
